<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content" ref="container">
        <!-- <HelperNav /> -->
          <div class="market-wrapper">

            <div class="row">
              <div class="col-lg-8 col-sm-12">
                
                <div class="ar-card size-sm market">
                  <div class="ar-card-header">
                    <div class="ar-card-title">نمودار</div>
                    <span></span>
                  </div>
                  <div class="ar-card-body">

                    <div v-if="chart_loading" class="market-loader-wrapper">
                      <span class="market-loader"></span>
                    </div>

                  </div>
                </div>
                
                <div class="pt-4">

                  <div class="row">
                        
                    <div class="col-lg-6 col-sm-12">

                    <div class="ar-card mt-4">
                      <div class="ar-tabs pt-2 px-2">
                        <div class="ar-tab-item" style="width:50%" :class="[buy_active_tab == 'market' ? 'active' : '']" @click="buy_active_tab = 'market'">
                          مارکت
                        </div>
                        <div class="ar-tab-item" style="width:50%" :class="[buy_active_tab == 'order' ? 'active' : '']" @click="buy_active_tab = 'order'">
                          سفارش گذاری
                        </div>
                      </div>

                      <div class="ar-card-body">
                        <div class="d-flex align-items-center justify-content-between text-primary-dark px-3">
                          <span>مقدار خرید</span>
                          <small>موجودی من: {{formatPrice(userData.user_detail.cash)}} تومان</small>
                        </div>
                        <div class="magic-input-box market mt-1 mb-0">
                          <div class="magic-input">
                            <input class="latin-input-3" @input="is_entered_number('buy_amount')" v-model="buy.amount">
                          </div>
                          <div class="magic-titr">تومان</div>
                        </div>
                        <small v-if="buy_errors.amount" class="text-danger">{{ buy_errors.amount[0] }}</small>

                        <template v-if="buy_active_tab == 'order'">
                          <div class="magic-input-box market slide-left mt-3 mb-1">
                            <div class="magic-input">
                              <input class="latin-input-3" @input="is_entered_number('buy_price')" v-model="buy.price">
                            </div>
                            <div class="magic-titr">قیمت</div>
                          </div>
                          <small v-if="buy_errors.price" class="text-danger">{{ buy_errors.price[0] }}</small>
                        </template>

                        <div class="text-center mt-3">
                          <button v-if="buy_loading" class="ar-btn size-md block round disabled"><div class="market-btn-loader"></div></button>
                          <button v-else class="ar-btn size-md block round success" @click="submitBuyReq()">خرید</button>
                        </div>
                      </div>
                    </div>
                      
                    </div>
                        
                    <div class="col-lg-6 col-sm-12">

                    <div class="ar-card mt-4">
                      <div class="ar-tabs pt-2 px-2">
                        <div class="ar-tab-item" style="width:50%" :class="[sell_active_tab == 'market' ? 'active' : '']" @click="sell_active_tab = 'market'">
                          مارکت
                        </div>
                        <div class="ar-tab-item" style="width:50%" :class="[sell_active_tab == 'order' ? 'active' : '']" @click="sell_active_tab = 'order'">
                          سفارش گذاری
                        </div>
                      </div>

                      <div class="ar-card-body">
                        <div class="d-flex align-items-center justify-content-between text-primary-dark px-3">
                          <span>مقدار فروش</span>
                          <small>موجودی من: {{userData.user_detail.tether}} تتر</small>
                        </div>
                        <div class="magic-input-box market mt-1 mb-0">
                          <div class="magic-input">
                            <input class="latin-input-3" @input="is_entered_number('sell_amount')" v-model="sell.amount">
                          </div>
                          <div class="magic-titr">تتر</div>
                        </div>
                        <small v-if="sell_errors.amount" class="text-danger">{{ sell_errors.amount[0] }}</small>

                        <template v-if="sell_active_tab == 'order'">
                          <div class="magic-input-box market slide-right mt-3 mb-1">
                            <div class="magic-input">
                              <input class="latin-input-3" @input="is_entered_number('sell_price')" v-model="sell.price">
                            </div>
                            <div class="magic-titr">قیمت</div>
                          </div>
                          <small v-if="sell_errors.price" class="text-danger">{{ sell_errors.price[0] }}</small>
                        </template>

                        <div class="text-center mt-3">
                          <button v-if="sell_loading" class="ar-btn size-md block round disabled"><div class="market-btn-loader"></div></button>
                          <button v-else class="ar-btn size-md block round danger" @click="submitSellReq()">فروش</button>
                        </div>
                      </div>
                    </div>
                      
                    </div>

                  </div>
                </div>
                

              </div>
              <div class="col-lg-4 col-sm-12">
                
                <div class="ar-card size-sm market">
                  <div class="ar-card-header">
                    <div class="ar-card-title">خریداران</div>
                    <span></span>
                  </div>
                  <div class="ar-card-body">
                    <div v-if="orders_loading" class="market-loader-wrapper">
                      <span class="market-loader"></span>
                    </div>

                    <table v-else class="market-prices-tbl buy">
                      <thead>
                        <tr>
                          <th>تعداد</th>
                          <th>قیمت</th>
                          <th>کل</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item , key) in buy_orders" :key="key">
                          <td>{{ item.amount }}</td>
                          <td>{{ formatPrice(item.price) }}</td>
                          <td>{{ formatPrice(item.total) }}</td>
                          <div class="after" :style="{width: item.percent + '%' }"></div>
                        </tr>
                        
                      </tbody>
                    </table>

                  </div>
                </div>

                <h4 class="my-3 text-primary-dark">قیمت تتر: 35900 تومان</h4>

                <div class="ar-card size-sm market">
                  <div class="ar-card-header">
                    <div class="ar-card-title">فروشندگان</div>
                    <span></span>
                  </div>
                  <div class="ar-card-body">
                    <div v-if="orders_loading" class="market-loader-wrapper">
                      <span class="market-loader"></span>
                    </div>

                    <table v-else class="market-prices-tbl sell">
                      <thead>
                        <tr>
                          <th>تعداد</th>
                          <th>قیمت</th>
                          <th>کل</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item , key) in sell_orders" :key="key">
                          <td>{{ item.amount }}</td>
                          <td>{{ formatPrice(item.price) }}</td>
                          <td>{{ formatPrice(item.total) }}</td>
                          <div class="after" :style="{width: item.percent + '%' }"></div>
                        </tr>
                        
                      </tbody>
                    </table>

                  </div>
                </div>

              </div>
            </div>

            <div class="ar-card mt-3 mb-5">
              <div class="ar-tabs mt-4 pt-2 px-2">
                <div class="ar-tab-item" :class="[list_active_tab == 'active_orders' ? 'active' : '']" @click="list_active_tab = 'active_orders'">
                  سفارشات فعال
                </div>
                <div class="ar-tab-item" :class="[list_active_tab == 'order_history' ? 'active' : '']" @click="list_active_tab = 'order_history'">
                  تاریخچه سفارشات
                </div>
                <div class="ar-tab-item" :class="[list_active_tab == 'trade_history' ? 'active' : '']" @click="list_active_tab = 'trade_history'">
                  تاریخچه معاملات
                </div>
              </div>
              <div class="ar-card-body">

                <template v-if="!list_loading">

                  <template v-if="list_active_tab == 'active_orders'">

                    <div class="table-responsive">
                      <table class="table ar-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>تاریخ و زمان</th>
                            <th>نوع</th>
                            <th>تعداد</th>
                            <th>قیمت</th>
                            <th>جمع</th>
                            <th>مقدار پر شده</th>
                            <th>لغو</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item , key) in active_orders" :key="key">
                            <td>{{ key + 1 }}</td>
                            <td>{{ item.create }}</td>
                            <td>
                              <template v-if="item.side == 'buy'">
                                <span class="text-success">خرید</span>
                              </template>
                              <template v-if="item.side == 'sell'">
                                <span class="text-danger">فروش</span>
                              </template>
                            </td>
                            <td>{{ item.amount }}</td>
                            <td>{{ formatPrice(item.price) }}</td>
                            <td>{{ formatPrice(item.total) }}</td>
                            <td>{{ item.filled_amount }}</td>
                            <td>لغو</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="!active_orders.length" class="p-4 text-center">شما سفارش فعالی ندارید.</div>

                  </template>

                  <template v-if="list_active_tab == 'order_history'">

                    <div class="table-responsive">
                      <table class="table ar-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>تاریخ و زمان</th>
                            <th>نوع</th>
                            <th>تعداد</th>
                            <th>قیمت</th>
                            <th>جمع</th>
                            <th>وضعیت</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item , key) in orders_history" :key="key">
                            <td>{{ key + 1 }}</td>
                            <td>{{ item.create }}</td>
                            <td>
                              <template v-if="item.side == 'buy'">
                                <span class="text-success">خرید</span>
                              </template>
                              <template v-if="item.side == 'sell'">
                                <span class="text-danger">فروش</span>
                              </template>
                            </td>
                            <td>{{ item.amount }}</td>
                            <td>{{ formatPrice(item.price) }}</td>
                            <td>{{ formatPrice(item.total) }}</td>
                            <td>
                              <template v-if="item.status == 1">
                                <span class="text-success">تکمیل شده</span>
                              </template>
                              <template v-if="item.status == 2">
                                <span class="text-danger">لغو شده</span>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="!orders_history.length" class="p-4 text-center">تاریخچه سفارشات شما خالی است.</div>

                  </template>

                  <template v-if="list_active_tab == 'trade_history'">

                    <div class="table-responsive">
                      <table class="table ar-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>تاریخ و زمان</th>
                            <th>نوع</th>
                            <th>تعداد</th>
                            <th>قیمت</th>
                            <th>جمع</th>
                            <th>پورسانت</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item , key) in trades_history" :key="key">
                            <td>{{ key + 1 }}</td>
                            <td>{{ item.create }}</td>
                            <td>
                              <template v-if="item.side == 'buy'">
                                <span class="text-success">خرید</span>
                              </template>
                              <template v-if="item.side == 'sell'">
                                <span class="text-danger">فروش</span>
                              </template>
                            </td>
                            <td>{{ item.amount }}</td>
                            <td>{{ formatPrice(item.price) }}</td>
                            <td>{{ formatPrice(item.total) }}</td>
                            <td>{{ item.commission }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="!trades_history.length" class="p-4 text-center">تاریخچه معاملات شما خالی است.</div>

                  </template>

                </template>

                <div v-else style="height:200px;">
                  <div class="market-loader-wrapper">
                    <span class="market-loader"></span>
                  </div>
                </div>

              </div>
            </div>

            <div class="py-5"></div>

          </div>
        </div>
      </div>
    </div>

    
    <!-- <modal @close="confirm_modal = false" :open="confirm_modal" :maxWitdh="'600px'">
      
      <div class="ar-card">
        <div class="ar-card-header">
          <span></span>
          <div class="ar-card-title">
            توجه 
          </div>
          <span>
            <i @click="confirm_modal = false" class="mdi mdi-close"></i>
          </span>
        </div>
        <div class="ar-card-body text-right">
          
          شما شبکه <span class="font-en">{{ admin_wallet.network }}</span> را برای انتقال انتخاب کرده اید. در صورت اطمینان از شبکه انتخاب شده عملیات خود را ادامه دهید.
          
        </div>
        <div class="ar-card-footer text-center">
          <button @click="confirm_modal = false" class="ar-btn size-sm primary mx-3">تایید</button>
        </div>
      </div>

    </modal> -->
    

  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import Modal from '../../components/Modal.vue'
import HelperNav from './partials/HelperNav'
import {io} from 'socket.io-client';
export default {
  name: 'Market',
  components:{
    Sidebar, Header, Modal, 
    HelperNav,
  },
  data : () => ({
    buy_active_tab:'market',
    sell_active_tab:'market',
    list_active_tab:'active_orders',

    sell_errors:{},
    buy_errors:{},
    errors:{},
    error_text:null,
    socket:null,

    orders_loading:true,
    chart_loading:true,
    sell_loading:false,
    buy_loading:false,
    list_loading:true,

    buy:{},
    sell:{},

    sell_orders:[],
    buy_orders:[],
    active_orders:[],
    orders_history:[],
    trades_history:[]

  }),
  computed:{
  },
  watch:{
  },
  methods:{
    is_entered_number(input)
    {
      let val;
      if(input === 'buy_amount'){
        val = this.buy.amount;
      }else if(input === 'buy_price'){
        val = this.buy.price;
      }else if(input === 'sell_price'){
        val = this.sell.price;
      }else if(input === 'sell_amount'){
        val = this.sell.amount;
      }
      const isNumeric = /^[-+]?(\d+|\d+\.\d*|\d*\.\d+)$/;
      if(!isNumeric.test(val)) {

        if(input === 'buy_amount'){
          this.buy.amount = null;
        }else if(input === 'buy_price'){
          this.buy.price = null;
        }else if(input === 'sell_amount'){
          this.sell.amount = null;
        }else if(input === 'sell_price'){
          this.sell.price = null;
        }

      }

      if(input === 'buy_amount'){
        if(parseFloat(this.buy.amount) > parseFloat(this.userData.user_detail.cash)){
          this.buy_errors.amount = ['به این اندازه موجودی ندارید.'];
        }else{
          this.buy_errors.amount = null;
        }
      }else if(input === 'sell_amount'){
        if(parseFloat(this.sell.amount) > parseFloat(this.userData.user_detail.tether)){
          this.sell_errors.amount = ['به این اندازه موجودی ندارید.'];
        }else{
          this.sell_errors.amount = null;
        }
      }
    },
    submitBuyReq (){
      this.buy_errors = {}
      this.buy_loading = true
      const api_token = this.getToken()
      this.buy.type = this.buy_active_tab
      this.$axios.post(`market/submitBuyReq` , this.buy,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( res => {
        this.buy_loading = false
        this.buy = {}
        
        this.$notify({
          group: 'foo',
          type: 'success',
          duration: 5000,
          text: res.data.message
        });

      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.buy_errors = error.errors
        }
        this.buy_loading = false
      });

    },
    submitSellReq (){
      this.sell_errors = {}
      this.sell_loading = true
      const api_token = this.getToken()
      this.sell.type = this.sell_active_tab
      this.$axios.post(`market/submitSellReq`,this.sell,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( () => {
        this.sell_loading = false
        this.sell = {};
        
        this.$notify({
          group: 'foo',
          type: 'success',
          duration: 5000,
          text: res.data.message
        });

      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.sell_errors = error.errors
        }
        this.sell_loading = false
      });

    },
    getAllOrders(){
      this.orders_loading = true
      const api_token = this.getToken()
      
      this.$axios.get(`market/getAllOrders`,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.sell_orders = res.data.data.sell_orders
        this.buy_orders = res.data.data.buy_orders
        this.orders_loading = false
      })
      .catch(err => {
        this.orders_loading = false
      });

    },
    getActiveOrders(){
      this.list_loading = true
      const api_token = this.getToken()
      
      this.$axios.get(`market/getActiveOrders`,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.active_orders = res.data.data
        this.list_loading = false
      })
      .catch(err => {
        this.list_loading = false
      });

    },
    getOrdersHistory(){
      this.list_loading = true
      const api_token = this.getToken()
      
      this.$axios.get(`market/getOrdersHistory`,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.orders_history = res.data.data
        this.list_loading = false
      })
      .catch(err => {
        this.list_loading = false
      });

    },
    getTradesHistory(){
      this.list_loading = true
      const api_token = this.getToken()
      
      this.$axios.get(`market/getTradesHistory`,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.trades_history = res.data.data
        this.list_loading = false
      })
      .catch(err => {
        this.list_loading = false
      });

    },
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.socket = io(this.socketUrl);
    this.checkConfirmed()
    
    this.getAllOrders()
    this.getActiveOrders()
    this.getOrdersHistory()
  }
}
</script>
